import type { CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveLogo = (state: CoreState): string | null | undefined => {
  return findActiveBrand(state)?.assets.logo
}
